/* Components */

/* Layout */
import Container from './components/Container';
import Header from './components/Header';
import Main from './components/Main';
import Footer from './components/Footer';

/* ETC */
import Nav from './components/Nav';
import NavItem from './components/NavItem';
import SplitPanel from './components/SplitPanel';
import Button from './components/Button';
import Link from './components/Link';
import Input from './components/Input';
import Card from './components/Card';
import Drawer from './components/Drawer';
import Avatar from './components/Avatar';
import Checkbox from './components/Checkbox';
import Icon from './components/Icon';
import DatePicker from './components/DatePicker';
import RadioGroup from './components/RadioGroup';
import RadioButton from './components/RadioButton';
import Dialog from './components/Dialog';
import Message from './components/Message';
import MessageBox from './components/MessageBox';
import Notification from './components/Notification';
import Carousel from './components/Carousel';
import CarouselItem from './components/CarouselItem';

import Sample from './components/Sample';

const components = [
    Container,
    Header,
    Main,
    Footer,
    Button,
    Link,
    Input,
    Nav,
    NavItem,
    SplitPanel,
    Card,
    Drawer,
    Avatar,
    Sample,
    Checkbox,
    Icon,
    DatePicker,
    RadioGroup,
    RadioButton,
    Dialog,
    Carousel,
    CarouselItem,
];

const install = function(Vue) {
    components.forEach(component => {
        Vue.component(component.name, component);
    });

    Vue.prototype.$msgbox = MessageBox;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$prompt = MessageBox.prompt;
    Vue.prototype.$notify = Notification;
    Vue.prototype.$message = Message;
};

export default {
    install,
    Container,
    Header,
    Main,
    Footer,
    Button,
    Link,
    Input,
    Nav,
    NavItem,
    SplitPanel,
    Card,
    Drawer,
    Avatar,
    Sample,
    Checkbox,
    Icon,
    DatePicker,
    RadioGroup,
    RadioButton,
    Dialog,
    Message,
    MessageBox,
    Notification,
    Carousel,
    CarouselItem,
};
